// export enum PermissionEnum {
//     view_dashboard_basic = "view_dashboard_basic",
//     view_dashboard_advanced = "view_dashboard_advanced",
//     manage_users_basic = "manage_users_basic",
//     manage_users_advanced = "manage_users_advanced",
//     edit_site_settings_basic = "edit_site_settings_basic",
//     edit_site_settings_advanced = "edit_site_settings_advanced",
//     deposit_table_basic = "deposit_table_basic",
//     deposit_table_advanced = "deposit_table_advanced",
//     transfer_table_basic = "transfer_table_basic",
//     transfer_table_advanced = "transfer_table_advanced",
//     sanctions_table_basic = "sanctions_table_basic",
//     sanctions_table_advanced = "sanctions_table_advanced",
//     users_table_basic = "users_table_basic",
//     users_table_advanced = "users_table_advanced",
//     charity_table_basic = "charity_table_basic",
//     charity_table_advanced  = "charity_table_advanced",
//     exchange_rate_basic = "exchange_rate_basic",
//     exchange_rate_advanced = "exchange_rate_advanced"
// }

export enum PermissionEnum {
    view_dashboard = "dashboard",
    manage_users = "users",
    users_table = "users",
    deposit_table = "transactions",
    transfer_table = "transactions",
    currencies = "currencies",
    sanctions_table = "compliance",
    exchange_rate = "exchange_rates",
    beneficiaries = "beneficiaries",
    charity_table = "charity",
    audit_trail = "audit_trail",
    marketing = "marketing"
}